const configDomain = 'https://www.intercartclothing.com';
const checkoutUrl = '/a/n/checkout/';

!(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
        n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

!function (e) {
    if (!window.pintrk) {
        window.pintrk = function () {
            window.pintrk.queue.push(
                Array.prototype.slice.call(arguments))
        };
        var
            n = window.pintrk;
        n.queue = [], n.version = "3.0";
        var
            t = document.createElement("script");
        t.async = !0, t.src = e;
        var
            r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(t, r)
    }
}("https://s.pinimg.com/ct/core.js");

// TikTok Pixel
!function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = w[t] = w[t] || [];
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"], ttq.setAndDefer = function (t, e) {
        t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
        }
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
        for (
            var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e
    }, ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
        ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
        n = document.createElement("script")
        ;n.type = "text/javascript", n.async = !0, n.src = r + "?sdkid=" + e + "&lib=" + t;
        e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(n, e)
    };
}(window, document, 'ttq');

(async function () {
    // 判断window.Shopify为空直接返回
    if (!window.Shopify) return;
    const current_shop_id = window.Shopify.shop.split('.')[0]
    const res = await fetch(`${configDomain}/api/shopify/configs/${current_shop_id}?configs=pixel`);
    const data = await res.json();

    // 保存 pixel 配置到 localStorage
    const pixelConfigs = {
        facebook: [],
        pinterest: [],
        tiktok: []
    };

    data.pixel_configs.forEach(p => {
        if (p.channel === 'facebook') {
            pixelConfigs.facebook.push(p.pixel_id);
            fbq('init', p.pixel_id);
            console.log('fbq init', p.pixel_id);
        } else if (p.channel === 'pinterest') {
            pixelConfigs.pinterest.push(p.pixel_id);
            pintrk('load', p.pixel_id);
            console.log('pinterest init', p.pixel_id);
        } else if (p.channel === 'tiktok') {
            pixelConfigs.tiktok.push(p.pixel_id);
            ttq.load(p.pixel_id);
            console.log('tiktok init', p.pixel_id);
        }
    });

    // 保存配置到 localStorage
    localStorage.setItem('pixelConfigs', JSON.stringify(pixelConfigs));

    // 触发 PageView 事件
    if (pixelConfigs.facebook.length > 0) {
        fbq('track', 'PageView');
    }
    if (pixelConfigs.pinterest.length > 0) {
        pintrk('page');
    }
    if (pixelConfigs.tiktok.length > 0) {
        ttq.page();
    }
})();

function getPixelConfigs() {
    const configs = localStorage.getItem('pixelConfigs');
    return configs ? JSON.parse(configs) : {facebook: [], pinterest: [], tiktok: []};
}

const LoadingAnimation = function () {
    let t = null;
    return {
        show: function () {
            var e;
            (t = t || ((e = document.createElement("style")).innerHTML = `
            .loader-container {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgba(255, 255, 255, 0);
                z-index: 9999;
                animation: fadeInBackground 3s forwards;
            }

            .custom-loader {
                width: 100px;
                height: 100px;
                border: 5px solid rgba(0, 0, 0, 0.1);
                border-radius: 50%;
                border-top-color: #0070ba;
                animation: spin 1s ease-in-out infinite;
                position: relative;
            }

            .spinnerImage {
                width: 50px;
                height: 50px;
                background: url("data:image/png;base64,UklGRnABAABXRUJQVlA4WAoAAAAQAAAAMQAAMQAAQUxQSPkAAAABgHNtmzFnFlVs2+nY2pVT2uyM1rbRmbublPwDtm3byRvPzBeWETEB6Ls0yhm6hqeVRk8uUzS6ACYbC2v6b2HRmRmOpw9FuuitWOgm5HEYYH+3boY+FudBOT2loy019FlOM/hRqwcL9Hmh2SMJSmpPTQjXFWIpRYMtFnt7kFLHGRcL1T0J0RkaR/iJYEhnaYBAABjRWSHh929n17O8snJ/vYJ/AFsrK8PJHAKmDwfdPN7kEA+/Z72bx5uAdAIpYIhosgbnCRSABBXEW/lnKjRnnDgUME7iD8dqdGIc/j9cDPhxaagvjRGQXQa6T14EkHhUXgHFZBP0lQEAVlA4IFAAAABwBQCdASoyADIAPrFCmEwnI6KiO+gA4BYJaQAAzFIU/21BJ4dSsxASuQcoDVJ87AtR8OBYAP7pnf/8Ce9/2aAf//gAXu38nRI/0tAAAAAAAA==") no-repeat center;
                background-size: contain;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            @keyframes spin {
                to { transform: rotate(360deg); }
            }

            @keyframes fadeInBackground {
                0% {
                    background-color: rgba(255, 255, 255, 0); 
                }
                100% {
                    background-color: rgba(255, 255, 255, 1);
                }
            }
        `, document.head.appendChild(e), (e = document.createElement("div")).className = "loader-container", e.innerHTML = `
            <div class="custom-loader">&#8203;</div>
            <div class="spinnerImage">&#8203;</div>
        `, document.body.appendChild(e), e)).style.display = "flex", document.body.style.overflow = "hidden"
        }, hide: function () {
            t && (t.style.display = "none", document.body.style.overflow = "")
        }
    }
}()

function generateTimestampedUUID() {
    return (new Date).getTime() + "_" + "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = 16 * Math.random() | 0;
        return ("x" === e ? t : 3 & t | 8).toString(16)
    })
}

function getCookie(e) {
    e = ("; " + document.cookie).split(`; ${e}=`);
    return 2 === e.length ? e.pop().split(";").shift() : ""
}

function toggleLoadingAnimation(e) {
    e ? LoadingAnimation.show() : setTimeout(function () {
        LoadingAnimation.hide()
    }, 5e3)
}


function getStoredFacebookAdsIds() {
    const n = JSON.parse(localStorage.getItem("easyTrack")) || {};
    return ["ad_id", "campaign_id", "adset_id"].reduce((e, t) => (e[t] = n[t] || "", e), {
        fbc: getCookie("_fbc"),
        fbp: getCookie("_fbp")
    })
}

function getOrCreateUserId() {
    var e = "myCartCustomerId";
    let t = localStorage.getItem(e);
    return t || (t = generateTimestampedUUID().split("_")[1], localStorage.setItem(e, t)), t
}

function getProductTitle() {
    // 优先使用 Shopify 内置数据
    if (window.ShopifyAnalytics?.meta?.product?.title) {
        return window.ShopifyAnalytics.meta.product.title;
    }

    // 尝试从 meta 标签获取
    var metaTitle = document.querySelector('meta[property="og:title"]');
    if (metaTitle) {
        return metaTitle.content;
    }

    // 从 DOM 获取
    var titleElement = document.querySelector('.product-title, h1.product__title, [itemprop="name"]');
    if (titleElement) {
        return titleElement.textContent.trim();
    }

    return null;
}


function setShopifyVariables() {
    return new Promise(e => {
        const t = () => {
            window.shopifyVariables = {
                shopId: window.Shopify.shop,
                clientId: getCookie("_shopify_y"),
                currency: window.Shopify.currency,
                country: window.Shopify.country
            };
            localStorage.setItem('shopifyVariables', JSON.stringify(window.shopifyVariables));
            e();
        };
        if (void 0 !== window.Shopify && window.Shopify.shop) t(); else {
            const n = new MutationObserver(() => {
                void 0 !== window.Shopify && window.Shopify.shop && (t(), n.disconnect())
            });
            n.observe(document, {childList: !0, subtree: !0})
        }
    })
}

async function my_product_checkout(e) {
    // console.log('Product checkout initiated:', productData)
    e && e.preventDefault();
    toggleLoadingAnimation(!0);

    try {
        // Get product information from the form
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) {
            throw new Error('Product form not found');
        }

        // Get variant ID and quantity from the form
        const variantId = form.querySelector('input[name="id"]').value;
        const productId = form.querySelector('input[name="product-id"]').value;
        const quantityInput = form.querySelector('input[name="quantity"]');
        const variantPrice = form.querySelector('input[name="quantity"]').dataset.price / 100;
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        if (!variantId) {
            throw new Error('Product variant ID not found');
        }
        // Add product to cart
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        });

        if (!addResponse.ok) {
            const errorData = await addResponse.json();
            throw new Error(errorData.description || 'Failed to add product to cart');
        }

        const addResult = await addResponse.json();
        // Call my_checkout function to proceed with checkout
        await my_checkout();

        return addResult;

    } catch (error) {
        console.error('Error in product checkout process:', error);
        toggleLoadingAnimation(!1);
        throw error;
    }
}

async function my_checkout(e) {
    e && e.preventDefault();
    toggleLoadingAnimation(!0);

    try {
        // Set Shopify variables first
        await setShopifyVariables();
        // Fetch cart data
        const cartResponse = await fetch('/cart.json', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });

        if (!cartResponse.ok) {
            throw new Error('network error');
        }

        const cartData = await cartResponse.json();
        const eventData = {
            content_ids: cartData.items.map(item => item.product_id),
            contents: cartData.items.map(item => ({
                product_id: item.product_id,
                title: item.title,
                quantity: item.quantity,
                item_price: item.price / 100
            })),
            num_items: cartData.item_count,
            value: cartData.total_price / 100,
            currency: window.shop_currency
        }

        const pixelConfigs = getPixelConfigs();

        // Facebook InitiateCheckout
        if (pixelConfigs.facebook.length > 0 && typeof fbq !== 'undefined') {
            fbq('track', 'InitiateCheckout', eventData);
        }

        // Pinterest InitiateCheckout
        if (pixelConfigs.pinterest.length > 0 && typeof pintrk !== 'undefined') {
            pintrk('track', 'initiatecheckout', {
                value: cartData.total_price / 100,
                order_quantity: cartData.item_count,
                currency: window.shop_currency,
                line_items: cartData.items.map(item => ({
                    product_id: item.product_id,
                    product_name: item.title,
                    product_price: item.price / 100,
                    product_quantity: item.quantity,
                    product_variant: item.variant_title,
                    product_variant_id: item.variant_id,

                }))
            });
        }

        // TikTok InitiateCheckout
        if (pixelConfigs.tiktok.length > 0 && typeof ttq !== 'undefined') {
            ttq.track('InitiateCheckout', {
                contents: cartData.items.map(item => ({
                    content_id: item.product_id,
                    content_type: 'product',
                    content_name: item.title,
                    quantity: item.quantity,
                    price: item.price / 100
                })),
                value: cartData.total_price / 100,
                currency: window.shop_currency
            });
        }

        const mergedData = {
            shopInfo: window.shopifyVariables,
            cartInfo: cartData,
            userId: getOrCreateUserId(),
            facebookInfo: getStoredFacebookAdsIds(),
            landing_page: window.location.href,
            timestamp: new Date().toISOString()
        };

        // console.log('InitiateCheckout', eventData);
        const apiResponse = await fetch(`${configDomain}/api/shopify/checkout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mergedData)
        });

        if (!apiResponse.ok) {
            throw new Error('API error');
        }
        const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        if (!clearResponse.ok) {
            throw new Error('Failed to clear cart');
        }
        const apiResult = await apiResponse.json();
        // console.log('API response:', apiResult);
        if (apiResult.token) {
            window.location.href = `${checkoutUrl}${apiResult.token}`;
        } else {
            window.location.href = `/cart`;
        }
        // Handle successful API response here
        // For example, redirect to checkout or show success message
        return apiResult;

    } catch (error) {
        console.error('Error in checkout process:', error);
        // Handle error appropriately
        throw error; // Re-throw if you want calling code to handle it
    } finally {
        toggleLoadingAnimation(!1);
    }
}

function trackProductViewContent() {
    const productContainer = document.querySelector('.productView-container');

    if (!productContainer) {
        console.warn('.productView-container not found');
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // 当元素进入视口且至少显示 50% 时触发
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const form = document.querySelector('form[data-type="add-to-cart-form"]');
                if (!form) {
                    console.warn('Product form not found');
                    return;
                }
                const productId = form.querySelector('input[name="product-id"]').value;
                const quantityInput = form.querySelector('input[name="quantity"]').value;
                const variantPrice = form.querySelector('input[name="quantity"]').dataset.price / 100;
                const productTitle = getProductTitle();

                const pixelConfigs = getPixelConfigs();

                // Facebook ViewContent
                if (pixelConfigs.facebook.length > 0 && typeof fbq !== 'undefined') {
                    const eventData = {
                        content_ids: [productId],
                        num_items: quantityInput,
                        contents: [
                            {
                                product_id: productId,
                                title: productTitle,
                                quantity: quantityInput,
                                price: variantPrice
                            }
                        ],
                        content_type: 'product',
                        value: variantPrice,
                        currency: window.shop_currency
                    }
                    fbq('track', 'ViewContent', eventData);
                    // console.log('ViewContent:', eventData)
                }

                // Pinterest ViewContent
                if (pixelConfigs.pinterest.length > 0 && typeof pintrk !== 'undefined') {
                    pintrk('track', 'pagevisit', {
                        product_id: productId,
                        product_name: productTitle,
                        product_price: variantPrice,
                        product_quantity: quantityInput,
                        currency: window.shop_currency
                    });
                }

                // TikTok ViewContent
                if (pixelConfigs.tiktok.length > 0 && typeof ttq !== 'undefined') {
                    ttq.track('ViewContent', {
                        content_id: productId,
                        content_type: 'product',
                        content_name: productTitle,
                        quantity: quantityInput,
                        price: variantPrice,
                        value: variantPrice,
                        currency: window.shop_currency
                    });
                }

                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: [0.5],
        rootMargin: '0px'
    });

    observer.observe(productContainer);
}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(trackProductViewContent, 1000);
});


const buttonIds = [
    'product-sticky-add-to-cart',
    'product-add-to-cart',
];

buttonIds.forEach(id => {
    const button = document.getElementById(id);
    if (button) {
        button.addEventListener('click', function () {
            if (this.getAttribute('data-tracked') !== 'true') {
                this.setAttribute('data-tracked', 'true');
                const form = document.querySelector('form[data-type="add-to-cart-form"]');
                if (!form) {
                    console.warn('Product form not found');
                    return;
                }
                const productId = form.querySelector('input[name="product-id"]').value;
                const quantityInput = form.querySelector('input[name="quantity"]').value;
                const variantPrice = form.querySelector('input[name="quantity"]').dataset.price / 100;
                const productTitle = getProductTitle();

                const pixelConfigs = getPixelConfigs();

                // Facebook AddToCart
                if (pixelConfigs.facebook.length > 0 && typeof fbq !== 'undefined') {
                    const eventData = {
                        content_ids: [productId],
                        num_items: quantityInput,
                        contents: [
                            {
                                product_id: productId,
                                title: productTitle,
                                quantity: quantityInput,
                                item_price: variantPrice
                            }
                        ],
                        content_type: 'product',
                        value: variantPrice,
                        currency: window.shop_currency,
                    }
                    fbq('track', 'AddToCart', eventData);
                }

                // Pinterest AddToCart
                if (pixelConfigs.pinterest.length > 0 && typeof pintrk !== 'undefined') {
                    pintrk('track', 'addtocart', {
                        value: variantPrice,
                        order_quantity: quantityInput,
                        currency: window.shop_currency,
                        product_id: productId,
                        product_name: productTitle
                    });
                }

                // TikTok AddToCart
                if (pixelConfigs.tiktok.length > 0 && typeof ttq !== 'undefined') {
                    ttq.track('AddToCart', {
                        content_id: productId,
                        content_type: 'product',
                        content_name: productTitle,
                        quantity: quantityInput,
                        price: variantPrice,
                        value: variantPrice,
                        currency: window.shop_currency
                    });
                }

                setTimeout(() => {
                    this.removeAttribute('data-tracked');
                }, 3000);
            }
        });
    }
});

async function checkoutWithVariant(variantId, quantity, upsellToken) {
    try {
        // Step 1: Clear cart
        const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        if (!clearResponse.ok) {
            throw new Error('Failed to clear cart');
        }

        // Step 2: Add variant to cart
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        });

        if (!addResponse.ok) {
            const errorData = await addResponse.json();
            throw new Error(errorData.description || 'Failed to add variant to cart');
        }

        const cartResponse = await fetch('/cart.json', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });

        if (!cartResponse.ok) {
            throw new Error('Failed to fetch cart data');
        }

        const cartData = await cartResponse.json();
        const shopifyVariables = JSON.parse(localStorage.getItem('shopifyVariables'));
        // Step 4: Submit to backend checkout API
        const mergedData = {
            shopInfo: shopifyVariables,
            cartInfo: cartData,
            userId: getOrCreateUserId(),
            facebookInfo: getStoredFacebookAdsIds(),
            upsell_token: upsellToken,
            landing_page: window.location.href,
            timestamp: new Date().toISOString()
        };

        const checkoutResponse = await fetch(`${configDomain}/api/shopify/checkout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mergedData)
        });

        if (!checkoutResponse.ok) {
            throw new Error('Checkout API request failed');
        }

        const checkoutResult = await checkoutResponse.json();

        if (!checkoutResult.token) {
            throw new Error('No token returned from checkout API');
        }
        return {
            success: true,
            token: checkoutResult.token,
            order_number: checkoutResult.order_number,
            cartInfo: cartData,
        };

    } catch (error) {
        console.error('Error in checkoutWithVariant:', error);
        return {
            success: false,
            error: error.message || 'Unknown error occurred'
        };
    }
}

